import React from 'react'
import { FaHeart } from 'react-icons/fa';
import './Footer.css'

const Footer = () => {
  return (
    <>
        <div className="Footer">
        <FaHeart className='icon'/> <a href="https://www.linkedin.com/in/harshvardhan-jha-b60148159/">Harshvardhan Jha</a><a href="https://github.com/harsh1kashyap">Github</a>
        </div>
    </>
  )
}

export default Footer